import { POSITIONS } from '../constants';

/**
 * Calculates whether the box is overflowing off the screen or not.
 * @param {String} options.position The box's base position.
 * @param {DOMRect} options.boxDimensions The box's dimensions.
 * @param {DOMRect} options.anchorDimensions The box's anchor dimensions.
 * @return {Boolean}
 */
const isOverflowing = ({
    position,
    boxDimensions,
    anchorDimensions
}) => {
    const {
        innerWidth,
        innerHeight
    } = window;

    switch (position) {
        case POSITIONS.LEFT:
            return anchorDimensions.left - boxDimensions.width < 0;
        case POSITIONS.RIGHT:
            return anchorDimensions.right + boxDimensions.width > innerWidth;
        case POSITIONS.TOP:
            return anchorDimensions.top - boxDimensions.height < 0;
        case POSITIONS.BOTTOM:
            return anchorDimensions.bottom + boxDimensions.height > innerHeight;
        default:
            return false;
    }
};

export default isOverflowing;
